import React, { useEffect, useState, useRef } from "react";
import { Navigate, useOutlet, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { getPageContent, updateCurrentScreen } from "../../utils";

export const ProtectedLayout = () => {
    const { user, isAuthenticated, getUserDetailsNotAsync, getUserDetails, setUserDetailsNotAsync } = useAuth();
    //getUserDetails();
    let userData = getUserDetailsNotAsync();
    const outlet = useOutlet();
    const location = useLocation();
    const navigate = useNavigate();
    const [authenticated, setAuthenticated] = useState(false);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const checkAuth = async () => {
            setLoaded(false);
            try {
                let value = await isAuthenticated();
                setAuthenticated(value);
            } catch {
                setAuthenticated(false);
            } finally {
                setLoaded(true);
            }
        };
        checkAuth();
    }, [location.pathname]);

    if (!loaded) {
        return null; // You can render a loading spinner or message here
    }

    if (user && userData?.contact && authenticated) {
        return <div>{outlet}</div>;
    }
    return (
        <Navigate
            to={"/signout" + (location.search ? location.search : "") + (location.hash ? location.hash : "")}
            state={{
                path: location.pathname + location.search + location.hash,
                query: (location.search ? location.search : "") + (location.hash ? location.hash : ""),
            }}
        />
    );
};
